<div class="error-container">
  <span class="error-message">{{ message | lang }}</span>
</div>
